"use client"

import styled from "@emotion/styled"
import Container from "@eurodrive/ui/Container"
import { getNonUmbracoUrl, getUmbracoMediaUrl } from "@eurodrive/utils"
import { imageGalleryInteraction } from "@eurodrive/utils/gtm"
import { Typography } from "@mui/material"
import { DetailedVehicleImage } from "api"
import Image from "next/image"
import { Swiper, SwiperSlide } from "swiper/react"

const StyledContainer = styled.div`
  padding: 64px 0;
  display: flex;
  flex-direction: column;
  gap: 40px;
  ${(props) => props.theme.breakpoints.up("md")} {
    text-align: center;
  }
`

const dummyData = [
  "/dummy/interior1.png",
  "/dummy/interior2.png",
  "/dummy/interior3.png",
  "/dummy/interior4.png",
  "/dummy/interior5.png",
]

const StyledSwiperSlide = styled(SwiperSlide)`
  width: 257px !important;
  height: 362px;
  border-radius: 8px;
  overflow: hidden;
  ${(props) => props.theme.breakpoints.up("md")} {
    width: 320px !important;
    height: 380px;
  }
  position: relative;
`
export default function InteriorCarousel({
  pictures,
  title,
  leasingPictures,
  vehicleId = "unknown",
}: {
  pictures: DetailedVehicleImage[]
  title?: string
  leasingPictures?: any
  vehicleId?: string
}) {
  const filtered = (pictures || []).filter((img) => {
    if (!img?.url) return false
    const match = img.url.match(/closeups\/cu-(\d+)\.(?:jpg|jpeg)$/i)
    if (!match) return false
    const num = parseInt(match[1], 10)
    return num >= 1 && num <= 17
  })

  const handleSlideChange = (swiper: any) => {
    imageGalleryInteraction(vehicleId, String(swiper.activeIndex + 1))
  }

  return (
    <StyledContainer>
      <Container paddingMobile>
        <Typography variant="h2">{title}</Typography>
      </Container>
      <Swiper
        spaceBetween={12}
        style={{
          margin: 0,
          display: "flex",
          width: "100%",
          padding: "0 20px",
        }}
        slidesPerView={"auto"}
        pagination={{ clickable: true }}
        onSlideChange={handleSlideChange}
        role="list"
        aria-label="גלריית תמונות הרכב"
      >
        {leasingPictures ? (
          <>
            {leasingPictures.map((item: any, index: number) => (
              <StyledSwiperSlide key={index} role="listitem">
                <Image
                  src={getNonUmbracoUrl(item.url)}
                  alt={item.altText || `תמונה ${index + 1}`}
                  fill
                  sizes="(min-width: 900px) 320px, 257px"
                  style={{ objectFit: "cover" }}
                />
              </StyledSwiperSlide>
            ))}
          </>
        ) : (
          <>
            {filtered.map((item, index) => (
              <StyledSwiperSlide key={index} role="listitem">
                <Image
                  src={getUmbracoMediaUrl(item.url)}
                  alt={item.label || `תמונה ${index + 1}`}
                  fill
                  sizes="(min-width: 900px) 320px, 257px"
                  style={{ objectFit: "cover" }}
                />
              </StyledSwiperSlide>
            ))}
          </>
        )}
      </Swiper>
    </StyledContainer>
  )
}
